<template lang="pug">
  div
    div.gridFull.pa-0
      v-row.flex-center.b-bottom.mb-0.no-gutters.main(:style="`top: ${headerHeight}px`")
        v-col.py-4.d-flex.items-center(md="4")
          .block-count.pl-4.font-weight-med
            span.mr-1(v-if="configs.length" ) {{configs.length}}
            span.mr-1(v-else) 0
            translate configuraciones
          button.primary-button(:disabled="!hasAutomaticConfigs" @click="showEditionModal=true")
            span.text-13 #[translate Añadir una Configuración]
        v-col(md="8")
          div.filters
            span.labelFilter #[translate Buscar restaurante]:
              div.filter.ml-2.mr-4
                input.filterBySearch(type="text" v-model="search")
                button.filterBySearchButton.clean(@click="cleanBySearch" v-if="$route.query.search || search")
                  img(:src="img.clean")
                button.filterBySearchButton(@click="filterBySearch")
                  img(:src="img.search")

            span.labelFilter.d-flex.items-center #[translate Nº estrellas]:
              div.filter.ml-2.mr-4
                filter-tree-menu(:options="starsNumber" label-class="text-capitalize-first-letter" :itemsChecked="selectedStarsMenu" @checked="onCheckStars" id-key="id" label-key="name")
            span.labelFilter.d-flex.items-center #[translate Texto]:
              div.filter.ml-2.mr-4
                filter-tree-menu(:options="textOptions" label-class="text-capitalize-first-letter" :itemsChecked="selectedTextMenu" @checked="onCheckText" id-key="id" label-key="name")
      v-row.no-gutters
        div.gr-loader-snipper--wrapper(v-if="loading")
          span.gr-loader-snipper
        v-expansion-panels
          v-expansion-panel
            v-expansion-panel-header Nivel
            v-expansion-panel-content
              v-expansion-panels(
                v-model="panel"
                multiple
              )
                v-expansion-panel(v-for="node in setAutomaticAnswersPerNode" :key="node.level")
                  v-expansion-panel-header {{`${node.nodeName} - ${node.config.length}`}}
                  v-expansion-panel-content
                    automatic-answers-table(
                      style="width:100%" 
                      :search="search" 
                      :configs="node.config" 
                      :loading="loading" 
                      :level-node="node.level"
                      @onEdit="handleEditButton" 
                      @onDelete="handleDeleteButton" 
                      :forceUpdateKey="forceUpdateKey"
                    )
        
    new-a-i-configuration-modal(v-if="showEditionModal" :isActive="showEditionModal" @onHidden="handleHidden" :initial-data="initialData" @handle-creation="handleNewItem" @handle-edition="handleEdition")
    modal-confirm-delete(:visible="showDeleteModal" @close="showDeleteModal=false" @confirmed="confirmDelete" :message="deleteMessage")
    modal-confirm-delete(:visible="showPermissionModal" @close="showPermissionModal=false" :message="permissionMessage")
</template>

<script>
import AutomaticAnswersTable from "@/components/feedback/AutomaticAnswersTable.vue"
import NewAIConfigurationModal from "@/components/feedback/NewAIConfigurationModal.vue"
import FilterTreeMenu from "@/components/filters/filterTreeMenu";
import SrvFeedback from "@/services/feedback";
import ModalConfirmDelete from "@/components/local/confirmDelete.vue"
import { AUTOMATIC_ANSWERS_NODES } from "@/helper/feedback/automaticAnswers";

export default {
  props: {},
  components: {AutomaticAnswersTable, FilterTreeMenu, NewAIConfigurationModal, ModalConfirmDelete},
  data() {
    return {
      showEditionModal: false,
      search: "",
      configs: [],
      img: {
        search: require('@/assets/img/buscar.svg'),
        clean: require('@/assets/img/borrar.svg')
      },
      starsNumber: [{id: 1, name: "1-2 estrella"}, {id: 2, name: "3 estrellas"}, {id: 3, name: "4 estrellas"}, {id: 4, name: "5 estrellas"}],
      textOptions: [{id: true, name: "Con texto"}, {id: false, name: "Sin texto"}],
      selectedStarsMenu: [],
      selectedTextMenu: [],
      hasText: null,
      stars: [],
      initialData: null,
      showDeleteModal: false,
      deleteId: null,
      loading: false,
      deleteMessage: this.$gettext('¿Estás seguro de que desea eliminar esta configuración?'),
      forceUpdateKey: 0,
      panel: [],
      showPermissionModal: false,
      permissionMessageDefault: this.$gettext('This node does not have automatic replies configured. You will be redirected to the nearest node that has this functionality.'),
      permissionMessage: this.$gettext('This node does not have automatic replies configured. You will be redirected to the nearest node that has this functionality.'),
      permissionMessage2: this.$gettext('Consult with your account manager.'),
      isRedirectingToEnabledNode: false,
    }
  },
  computed: {
    hasAutomaticConfigs() {
      return this.$store.getters.getHasAiReplyConfig
    },
    headerHeight() {
      return this.$store.getters.getTopSectionHeight - 2
    },
    breadcrumb() {
      return this.$store.getters.getBreadcrumb;
    },
    setAutomaticAnswersPerNode(){
      let nodesNames = JSON.parse(JSON.stringify(AUTOMATIC_ANSWERS_NODES));

      this.configs.forEach(config => {
        const {node, center} = config;
        if(node && nodesNames[node.level]) {
          nodesNames[node.level].config.push(config);
        } else if(center) {
          nodesNames[9].config.push(config);
        }
      });
      const nodeLevels = Object.keys(nodesNames)
      const visibleLevels = new Set(
        Object.keys(this.getAvailableNodes || {})
          .map((level) => Number(level))
          .filter((level) => nodesNames[level])
      )

      if (!visibleLevels.size) {
        return nodeLevels.map(level => nodesNames[level])
      }

      return nodeLevels
        .filter(level => visibleLevels.has(Number(level)))
        .map(level => nodesNames[level]);
    },
    getAvailableNodes() {
      if (!this.breadcrumb) return;

      const breadcrumbs = this.breadcrumb.split("-");
      const slug = breadcrumbs[1] !== 'N' ? `${breadcrumbs[0]}-${breadcrumbs[1]}` : breadcrumbs[0];
      const levels = {};

      //Getting the parent and children of the node
      const itemsTree = document.querySelectorAll('[data-slug^="' + slug + '"]');

      //Getting the brand of the node
      const brand = itemsTree[0]?.parentElement?.querySelector(".itemTreeInfo");

      itemsTree.forEach((itemTree) => {
        const itemTreeLevel = itemTree?.dataset?.level;

        if(itemTreeLevel) {
          levels[itemTreeLevel] = itemTreeLevel;
        }
      });

      if(brand) {
        const brandLevel = brand?.dataset?.level;
        levels[brandLevel] = brandLevel;
      }

      return levels;
    }
  },
  mounted() {
    this.getAutomaticAnswersConfigs();
    if (!this.hasAutomaticConfigs) {
      this.handleNoPermission()
    }
  },
  watch: {
    hasAutomaticConfigs(newValue, oldValue) {
      if (newValue || this.isRedirectingToEnabledNode || oldValue === undefined) return
      this.handleNoPermission()
    }
  },
  methods: {
    handleNoPermission() {
      this.showPermissionModal = true

      const nearestNode = this.getNearestEnabledNodeElement()
      const currentSlug = this.getCurrentNodeSlug()
      const targetSlugRaw = nearestNode?.dataset?.slug
      const targetSlug = targetSlugRaw ? String(targetSlugRaw).replace(/-(N|C)$/, "") : null

      const canRedirect =
        !!nearestNode && !!targetSlug && !!currentSlug && targetSlug !== currentSlug

      if (!canRedirect) {
        this.permissionMessage = this.permissionMessage2
        return
      }

      this.permissionMessage = this.permissionMessageDefault
      this.redirectToNearestEnabledNode(nearestNode)
    },
    getCurrentNodeSlug() {
      const rawBreadcrumb = this.breadcrumb
      if (rawBreadcrumb) {
        return String(rawBreadcrumb).replace(/-(N|C)$/, "")
      }

      const routeParam = this.$route?.params?.paramCOD || ""
      return routeParam.replace(/-(N|C)$/, "")
    },
    getSlugDistance(slugA, slugB) {
      if (!slugA || !slugB) return Number.MAX_SAFE_INTEGER

      const left = slugA.split("-")
      const right = slugB.split("-")
      let common = 0

      while (common < left.length && common < right.length && left[common] === right[common]) {
        common++
      }

      return (left.length - common) + (right.length - common)
    },
    getNearestEnabledNodeElement() {
      const currentSlug = this.getCurrentNodeSlug()
      const enabledNodesAll = Array.from(document.querySelectorAll('.itemTreeInfo[data-has-ai-reply-config="true"]'))

      if (!enabledNodesAll.length || !currentSlug) return null

      let nearestNode = null
      let nearestDistance = Number.MAX_SAFE_INTEGER

      const currentParts = String(currentSlug).split("-").filter(Boolean)

      enabledNodesAll.forEach((nodeElement) => {
        const nodeSlug = nodeElement?.dataset?.slug
        if (!nodeSlug) return

        const normalizedNodeSlug = String(nodeSlug).replace(/-(N|C)$/, "")
        const nodeParts = normalizedNodeSlug.split("-").filter(Boolean)

        // Candidate must be in the same branch: the slugs should share the same prefix
        // (either current is a prefix of candidate OR candidate is a prefix of current).
        const currentIsPrefixOfCandidate =
          nodeParts.length >= currentParts.length && currentParts.every((p, idx) => nodeParts[idx] === p)
        const candidateIsPrefixOfCurrent =
          currentParts.length >= nodeParts.length && nodeParts.every((p, idx) => currentParts[idx] === p)

        if (!currentIsPrefixOfCandidate && !candidateIsPrefixOfCurrent) return

        const distance = this.getSlugDistance(currentSlug, normalizedNodeSlug)

        if (distance < nearestDistance) {
          nearestDistance = distance
          nearestNode = nodeElement
        }
      })

      return nearestNode
    },
    redirectToNearestEnabledNode(nearestNode) {
      if (this.isRedirectingToEnabledNode) return

      if (!nearestNode) {
        this.permissionMessage = this.permissionMessage2
        return
      }

      this.isRedirectingToEnabledNode = true
      window.setTimeout(() => {
        const currentSlug = this.getCurrentNodeSlug()
        const targetSlugRaw = nearestNode?.dataset?.slug
        const targetSlug = targetSlugRaw ? String(targetSlugRaw).replace(/-(N|C)$/, "") : null

        const canRedirect =
          !!nearestNode && !!targetSlug && !!currentSlug && targetSlug !== currentSlug

        if (canRedirect) {
          nearestNode.click()
          this.showPermissionModal = false
        } else {
          // We couldn't redirect anymore, show permissionMessage2 and keep the modal open.
          this.permissionMessage = this.permissionMessage2
          this.showPermissionModal = true
        }

        this.isRedirectingToEnabledNode = false
      }, 3000)
    },
    async confirmDelete() {
      try {
        this.loading = true
        await SrvFeedback.deleteAutomaticAnswer(this.deleteId)
        this.configs = this.configs.filter(item => item.id !== this.deleteId)
      } catch (error) {
        console.error("[ERROR_confirmDelete]:", error)
      } finally {
        this.deleteId = null;
        this.loading = false
      }
    },
    handleDeleteButton(id) {
      this.showDeleteModal = true
      this.deleteId = id
    },
    handleNewItem(item) {
      this.configs = [...this.configs, item]
    },
    handleEdition(item) {
      const index = this.configs.findIndex(config => config.id === item.id)
      if (index >= 0) {
        this.configs = this.configs.map((config) => {
          if (config.id === item.id) {
            return item
          }
          return config
        })
        this.forceUpdateKey++
      }
    },
    handleEditButton(item) {
      const formatedStars = item.ratings.map(item => {
        return (item).toString()
      })
      this.initialData = {...item, ratings: formatedStars}
      this.showEditionModal = true
    },
    onCheckText(selected) {
      if (selected.length === 1) {
        this.hasText = selected?.[0].value
      } else {
        this.hasText = null
      }

      this.getAutomaticAnswersConfigs()
    },
    onCheckStars(selected) {
      this.stars = selected.map((item) => item.value)

      this.getAutomaticAnswersConfigs()
    },
    handleHidden() {
      this.showEditionModal = !this.showEditionModal
      if (!this.showEditionModal) {
        this.initialData = null
      }
    },
    cleanBySearch() {
      this.search = ''
    },
    filterBySearch() {
      this.getAutomaticAnswersConfigs()
    },
    async getAutomaticAnswersConfigs() {
      try {
        const {data: {results}} = await SrvFeedback.getAutomaticAnswersConfigs({search: this.search, hasText: this.hasText, stars: this.stars})
        this.configs = results.map(result => {
          return {...result}
        })
      } catch (error) {
        // console.error("[ERROR: getAutomaticAnswersConfigs]:", error)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.primary-button {
  background-color: #00ADFC;
  padding: 10px 20px;
  margin-left: 46px;
  border-radius: 4px;

  span {
    color: white;
  }

  &:disabled {
    background-color: #d3d3d3;
    cursor: not-allowed;

    span {
      color: #888888;
    }
  }
}

.filterBySearch {
  vertical-align: middle;
  font-size: 0.75rem;
  border: 1px solid #D7DAE2;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: 0;
  background: white;
  color: #1976d2;
  height: 34px;
  padding-left: 16px;
}

.filterBySearchButton {
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #D7DAE2;
  border-left: 0;
  height: 34px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 0 10px;

  &.clean {
    border-right: 1px solid #D7DAE2;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  img {
    width: 14px;
    margin-top: 5px;
  }
}

.main {
  position: sticky;
  z-index: 2;
  background: #fff;
  overflow-y: hidden;
}

.action-button {
  background-color: #EBEBEB;
  border-radius: 2px;
  max-width: fit-content;
}
</style>
